export default __webpack_public_path__ + "sad_face.png";